
export type IssueReceiptBody = {
  amount?: number;
  orderId: string;
  productName?: string;
  template?: string;
  userId?: string;
};
